import * as React from 'react';
import { Grid } from 'semantic-ui-react';

const Campo: React.FunctionComponent<{
    etiqueta?: string;
    valor: React.ReactNode;
    ocultar?: boolean;
}> = props => {
    const { etiqueta, valor, ocultar } = props;

    return ocultar ? null : (
        <Grid.Row style={{ marginBottom: '0.3em' }}>
            <span
                style={{
                    verticalAlign: 'top',
                    display: 'inline-block',
                    minWidth: '15em',
                }}
            >
                {etiqueta ? etiqueta + ':' : ''}
            </span>
            <span
                style={{
                    display: 'inline-block',
                    maxWidth: '23em',
                    fontWeight: 'bold',
                }}
            >
                {valor}
            </span>
        </Grid.Row>
    );
};

export default Campo;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/Campo.tsx